module.exports = __webpack_public_path__ + "static/media/fish-tank-sparkling.06b2fedf.png";